import { createId } from '../model/factories';
import { AdElement } from '../model/types';

/**
 * Schowek edytora, celowo w pamięci modułu, a nie w schowku systemowym.
 *
 * Kopiujemy obiekty sceny, a nie tekst czy obraz, więc systemowy schowek i tak
 * nie przeniósłby ich w użytecznej formie. Skutek uboczny: kopiowanie działa
 * w obrębie karty przeglądarki, co przy pracy nad jedną kreacją wystarcza.
 */
let clipboard: AdElement[] = [];

export const copyElements = (elements: AdElement[]): void => {
  clipboard = elements.map((element) => ({ ...element }));
};

export const hasClipboard = (): boolean => clipboard.length > 0;

/**
 * Kopie gotowe do wstawienia: nowe identyfikatory i przesunięcie, żeby nie
 * zniknęły dokładnie pod oryginałem.
 *
 * @param {number} offset przesunięcie w pikselach planszy.
 * @return {AdElement[]} nowe elementy do dodania na planszę.
 */
export const pasteElements = (offset: number): AdElement[] => clipboard.map((element) => ({
  ...element,
  id: createId(),
  name: `${element.name} (kopia)`,
  x: element.x + offset,
  y: element.y + offset,
}));
